import { render } from "./OnlineTest.vue?vue&type=template&id=3b2955d4"
import script from "./OnlineTest.vue?vue&type=script&lang=js"
export * from "./OnlineTest.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__